import React from 'react'
import { FieldExtensionSDK } from 'contentful-ui-extensions-sdk'
const ExtensionContext = React.createContext<{sdk?: FieldExtensionSDK, loading: boolean}>(
    {loading: true, sdk: undefined}
  );
  
export default ExtensionContext 